const OCEAN_IMAGE =
  "https://images.unsplash.com/photo-1468581264429-2548ef9eb732?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000";

export default function Maintenance() {
  return (
    <main
      data-testid="maintenance-screen"
      className="relative min-h-screen w-full flex items-center justify-center overflow-hidden bg-[#0B1C26]"
    >
      <img
        src={OCEAN_IMAGE}
        alt=""
        aria-hidden="true"
        className="absolute inset-0 h-full w-full object-cover opacity-70"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-[#0B1C26]/70 via-[#0B1C26]/55 to-[#0B1C26]/85" />

      <section className="relative z-10 max-w-xl px-8 text-center">
        <div className="mx-auto mb-8 h-px w-16 bg-[#C5A059]" />
        <p
          className="text-[0.62rem] tracking-[0.34em] uppercase text-[#C5A059]"
          data-testid="maintenance-eyebrow"
        >
          Gemma Veda · Author
        </p>
        <h1
          className="mt-6 font-serif text-4xl sm:text-5xl leading-tight text-white"
          data-testid="maintenance-heading"
        >
          The site is resting
          <span className="block text-[#C5A059]">for a little while.</span>
        </h1>
        <p
          className="mt-6 text-base text-white/75 leading-relaxed"
          data-testid="maintenance-message"
        >
          We&apos;re carrying out some scheduled maintenance behind the scenes.
          The stories, the books and the journal will all be here when the tide
          turns. Please do come back soon.
        </p>
        <p className="mt-10 text-xs tracking-[0.2em] uppercase text-white/45">
          With warmth, Gemma
        </p>
        <div className="mx-auto mt-8 h-px w-16 bg-white/20" />
      </section>
    </main>
  );
}
